import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';


const useStyles = makeStyles((theme) => ({
   campoLabel: {
      alignSelf: 'center',
      paddingRight: theme.spacing(1),
      wordWrap: 'break-word',
      minWidth: '100px',
      width: '150px',
      cursor: 'default',
      float: 'left'
   },

   contenedor: {
      display: 'flex',
      width: '100%'
   },
   campo: {
      boxSizing: 'border-box',
      float: 'right',
      width: '100%'
   }
}));
/**
 * Agrega un label en el lado derecho de un componente. Cualquier otra propiedad sera redireccionada al componente *dsComponent*
 */
function LabelComponent(
   {
      dsLabel,
      dsComponent,
      dsButton,
      dsClassNameLabel,
      ...otherProps
   }
) {
   const classes = useStyles();
   const Component = dsComponent || TextField;

   return (
      <div className={classes.contenedor}>
         {dsLabel && <Typography className={clsx(classes.campoLabel,dsClassNameLabel)}>{dsLabel}:</Typography>}
         <div className={classes.campo}>
            <Component {...otherProps} />
         </div>
         {dsButton}
      </div>
   );
}
LabelComponent.propTypes = {
   /**
    * Texto label a mostrar.
    */
   dsLabel: PropTypes.string,
   /**
    * Componente al cual se desea agregar el label a lado derecho. Cualquier otra propiedad sera redireccionada a este componente.
    */
    dsComponent: PropTypes.elementType,
   /**
    * Clase asignar al label del componente
    */
    dsClassNameLabel: PropTypes.string
    
};
export default LabelComponent;
